module.exports = __webpack_public_path__ + "img/fp-folded.b7671414.webp";